// 国家排名 tab
import React from 'react'
import { isRtl } from 'src/helper/tool'
import RankingItem from '../ranking-item'

import './index.less'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  render() {
    const { countryList, tabType, lang, language } = this.props
    return (
      <div className='tab-national-cont'>
        <div className='hd'>
          <h2>{lang.this_week_global_star}</h2>
        </div>
        <div className='bd'>
          {/* 背景图层 */}
          <div className="bd-bg">
            <div className="last-week-bg">
              <img src="/img/activity/national-star/img_rank_nation_bg@2x.png" />
            </div>
            <div className="bd-bg-list">
              <div className="top">
                <img src="/img/activity/national-star/img_box_bg_frame_top@2x.png" />
              </div>
              <div className="min"></div>
              <div className="bottom">
                <img src="/img/activity/national-star/img_box_bg_frame_bot@2x.png" />
              </div>
            </div>
          </div>
          {/* 背景图层  end */}
          <div className="podium-wrap">
            {
              countryList &&
              countryList.slice(0, 3).map((item, index) => {
                return (
                  <div
                    className={`level
                      ${index === 0 ? 'champion' : ''}
                      ${index === 1 ? 'second' : ''}
                      ${index === 2 ? 'third' : ''}`
                    }
                    key={item.countryId}
                  >
                    <div className="level-cont">
                      <div className="img-wrap">
                        {
                          item.headUrl && (
                            <div className="decorate">
                              <img src={item.headUrl} />
                            </div>
                          )
                        }
                        <div className="flag">
                          <img src={item.countryIcon} />
                        </div>
                      </div>
                      <div className="level-item-info">
                        <p className='name'>
                          {item.countryName}
                        </p>
                        <div className="number-wrap">
                          <img src={item.giftIcon} alt="" />
                          {/* {numberThumbnail(item.score)} */}
                          {item.score}
                        </div>
                        <div className={`avatar-warp ${isRtl(language) ? 'arlang' : ''}`}>
                          {
                            item.avatarurlList &&
                            item.avatarurlList.map(avatar => {
                              return (
                                <div className="avatar-item" key={avatar}>
                                  <img src={avatar} />
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
        <div className="ranking-wrap">
          {
            countryList &&
            countryList.slice(3).map((item, index) => {
              return (
                <RankingItem
                  key={item.countryId}
                  type={tabType}
                  item={item}
                  index={index}
                  language={language}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/tab-national/index.js